function WorkOrderUpload({ selectedSite, onUploadSuccess }) {
  return null;
}

export default WorkOrderUpload;
